var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTemplate(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.11h28v17.917a3 3 0 01-3.002 2.967H5.002A3.002 3.002 0 012 27V9.083v.028z",
    fill: "#6CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.534 2h20.932A3.534 3.534 0 0130 5.533v1.68H2v-1.68A3.533 3.533 0 015.534 2z",
    fill: "#FFA64D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.093 12.778v10.99a1.68 1.68 0 01-1.68 1.68H5.73a1.68 1.68 0 01-1.68-1.68v-10.99a1.707 1.707 0 011.68-1.68h7.66a1.709 1.709 0 011.68 1.68h.023zM27.055 26.87H4.66a.633.633 0 100 1.265h22.395a.633.633 0 100-1.265zM27.693 12.727v3.27a1.68 1.68 0 01-1.68 1.652h-7.734a1.636 1.636 0 01-1.22-.56 1.68 1.68 0 01-.426-1.12v-3.242a1.68 1.68 0 011.646-1.651h7.762a1.68 1.68 0 011.652 1.651zM27.693 20.532v3.304a1.68 1.68 0 01-1.68 1.646h-7.734a1.646 1.646 0 01-1.646-1.646v-3.304a1.646 1.646 0 011.646-1.646h7.762a1.68 1.68 0 011.652 1.646z",
    fill: "#E6F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.209 5.79a1.181 1.181 0 100-2.362 1.181 1.181 0 000 2.362zM9.56 5.79a1.181 1.181 0 100-2.362 1.181 1.181 0 000 2.362zM13.911 5.79a1.181 1.181 0 100-2.362 1.181 1.181 0 000 2.362zM14.37 11.39L4.027 20.475v-7.698a1.708 1.708 0 011.68-1.68h7.683a1.68 1.68 0 01.98.291zM23.935 11.076l-6.877 6.04a1.68 1.68 0 01-.425-1.119v-3.27a1.68 1.68 0 011.646-1.651h5.656zM22.765 18.886l-6.082 5.342a1.594 1.594 0 01-.05-.404v-3.292a1.646 1.646 0 011.646-1.646h4.486z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgTemplate;